import React from 'react';
import Header from '../common/Header/Header';
import Banner from '../common/Banner/Banner';
import BookDemo from '../common/BookDemo/BookDemo';
import OurCustomers from '../common/OurCustomers/OurCustomers';
import Assessment from '../common/Assessment/Assessment';
import SuccessPath from '../common/SuccessPath/SuccessPath';
import InterviewHub from '../common/InterviewHub/InterviewHub';
import Empower from '../common/InterviewHub/Empower/Empower';
import WhyBookDemo from '../common/Blogs/WhyBookDemo/WhyBookDemo';
import Footer from '../common/Footer/Footer';

function WelcomeInstitution() {
  return (
    <main>
      <Header role="college" />
      <Banner role="college" />
      <BookDemo role="college" />
      <OurCustomers />
      <Assessment />
      <SuccessPath role="college" />
      <InterviewHub role="college" />
      <Empower role="college" />
      <WhyBookDemo role="college" />
      <Footer />
    </main>
  );
}

export default WelcomeInstitution;
